import React, { Component } from "react"
import TableUsuariosTrash from "./TableUsuariosTrash"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
export default class UsuariosTrash extends Component {
  constructor() {
    super()
    this.getUsuarios = this.getUsuarios.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { usuarios: [], initialUsuarios: [], showTable: false }
  }
  componentWillMount() {
    this.getUsuarios()
  }
  getUsuarios() {
    ApiHelper.getUsuariosTrash((usuarios, error) => {
      if (usuarios) {
        this.setState({
          usuarios: usuarios,
          initialUsuarios: usuarios,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didRestore() {
    this.getUsuarios()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialUsuarios.filter(usuario => {
      return (
        usuario.nome.toLowerCase().search(searchText) !== -1 ||
        usuario.cpf.toLowerCase().search(searchText) !== -1 ||
        usuario.email.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      usuarios: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Operadores">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Operadores">
        {this.state.showTable ? (
          <TableUsuariosTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title={"Usuários do sistema deletados"}
            subtitle={
              "Listagem de todos os usuários do sistema deletados anteriormente"
            }
            backgroundColor="as-blue"
            rows={this.state.usuarios}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/usuarios/UsuariosTrash.js